import clsx from "clsx";

import type { ReactNode } from "react";

interface PlanStatCardProps {
  title: string;
  children: ReactNode;
  action?: ReactNode;
}

export default function PlanStatCard({
  title,
  children,
  action,
}: PlanStatCardProps) {
  return (
    <div className="p-1 bg-white rounded-4xl border border-black-100">
      <div
        className={clsx([
          "flex h-full flex-col p-5 rounded-3xl border border-black-200 bg-whiteGray",
          action ? "gap-2" : "gap-4",
        ])}
      >
        <span className="text-xs-medium text-black-500">{title}</span>

        <div className="flex flex-row gap-4 justify-between items-center">
          <div className="flex flex-row gap-2.5 items-center">{children}</div>

          {action}
        </div>
      </div>
    </div>
  );
}
